module.exports = __webpack_public_path__ + "images/kpn_small82ba202e377ef2647387a353420f77a5.png";